export const UVA_HERITAGE_THRESHOLD = 200_000;

export const UVA_HERITAGE_THRESHOLD_FORMATTED =
  UVA_HERITAGE_THRESHOLD.toLocaleString("es-AR", {
    maximumFractionDigits: 0,
  });

export interface UvaIndicatorResponse {
  description: string;
  value: number;
  retrievalDate: string;
}

export const getPatrimonioThresholdAmount = (uvaUnitValue: number) =>
  UVA_HERITAGE_THRESHOLD * uvaUnitValue;

export const getPatrimonioThresholdString = (uvaUnitValue: number) =>
  getPatrimonioThresholdAmount(uvaUnitValue).toLocaleString("es-AR", {
    maximumFractionDigits: 0,
  });

export const formatPatrimonioThreshold = (uvaUnitValue: number) =>
  `$${getPatrimonioThresholdString(uvaUnitValue)}`;
